/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-console */
import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import {
    Grid,
    Row,
    Column,
    Keyboard,
    Button,
    Heading,
    Form,
    FormInput,
    cls,
    HeaderCompound
} from 'packages/components';
import { connect } from 'react-redux';
import Translator from '../../requests/apa/Translator';
import { autobind } from 'packages/core/lib';
import { PAYMENT_TELCEL } from '../utils/constants';
import { showModal, AAF_MODAL_SUCCESS_SUSCRIPTION } from '../../actions/modal';
import { apiPaywayConfirm, onPaymetSuccess, showError, getWorkflow, GetRegExpMovil, isModalHide, setInitialFocus, onFocusMultipleElements, handleTypeModal, filterInputValue, redirectPlayerOneClic } from '../utils/Utils';
import Assets from '../../requests/apa/Asset';
import UtilsPagos from '../../utils/payway/UtilsPagos';
import Device from '../../devices/device';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import Spinner from '../../components/Spinner';
import './_styles.scss';
import { setMetricsEvent } from '../../actions/metrics';
import { SUSCRIPCION_CLARO_VIDEO_REGISTRO, EXITOSO_MENSUAL_ANUAL_METODO_DE_PAGO, CANCELAR_MEDIO_PAGO, METODO_DE_PAGO, COMPONENTE_TICKER, COMPONENT_SUSCRIPCION, ADD_ON_REGISTRO, CLAROVIDEO, COMPRAS_VCARD, ADD_ON_VCARD, ADD_ON_TV } from '../../authentication/utils/constansMetrics';
import Utils, { enablePaymentMethodExperience } from '../../utils/Utils';
import { getTransactionalPrice, getTransactionalTax, getTransactionalBonus} from '../utils/Utils';
import {TRANSACTION_COMPONENT_TICKET} from '../utils/constants';
import {GA4} from 'src/utils/trackers/GA4';
import {PAYMENT_METHOD_TELCEL} from 'src/utils/trackers/GA4Constants';

enum Steps {
    STEP_NUMBER = 'INSERT_NUMBER',
    STEP_PIN = 'INSERT_PIN',
}
interface IStepsValue {
    [key: string]: string | undefined;
    header: string;
    title: string | undefined;
    subtitle: string;
    next?: string;
    cancel?: string;
}

interface IHubGateState {
    form: {
        mobile?: string;
        document?: string;
        pin?: string;
        account?: string;
        access_pin_token?: string;
    };
    step: string;
    errorFromBackend: string;
    errorFromBackendDoc: string;
    pbi: any;
    worflowstart: any;
    selectedPaymentMethod: string;
    type: number;
    isLoading: boolean;
    hasDocument: boolean;
    wfs: any;
    activeElement: string;
    element: any;
}

class HubGate extends Component<RouteComponentProps, IHubGateState> {
    public textSendPin: string = Translator.get('', 'Reenviar pin');
    private isValidForm: boolean;
    public keys = (Device.getDevice() && Device.getDevice().getKeys()) || null;
    private temp: any = document;
    public subtitleLabel: string = Translator.get('hubgate_access_subtitle_label');
    private from: string = '';

    constructor(props: RouteComponentProps) {
        super(props);
        const { location: { state = {} } = {} } = props || {};
        this.from = state?.from;
        this.state = {
            form: {
                mobile: '',
                document: '',
                pin: '',
                account: '',
                access_pin_token: ''
            },
            isLoading: false,
            step: Steps.STEP_NUMBER,
            errorFromBackend: '',
            errorFromBackendDoc: '',
            pbi: {},
            worflowstart: {},
            selectedPaymentMethod: '',
            type: 0,
            hasDocument: false,
            wfs: {},
            activeElement: '',
            element: ''
        };
    }

    public componentDidMount(): void {
        document && document.removeEventListener('keydown', this.onKeyPress, true);
        document && document.addEventListener('keydown', this.onKeyPress, true);
        document && document.addEventListener('sn:enter-up', this.enterUpHandler, true);
        const selectedPaymentMethod = this.props.location.state.method;
        const {
            location: {
                state: { type, pbi, worflowstart },
            },
        } = this.props;
        const hasDocument = UtilsPagos.hasDocument(selectedPaymentMethod);
        if (pbi && worflowstart && type) {
            const wfs = getWorkflow(selectedPaymentMethod, worflowstart);
            this.setState({
                pbi,
                worflowstart,
                selectedPaymentMethod,
                type,
                hasDocument,
                wfs
            }, () => {
                if (isModalHide()) {
                    setInitialFocus('.aaf_form-group-input-element .aaf_focusable', false);
                }
            });
        }
    }

    public componentWillUnmount(): void {
        document && document.removeEventListener('keydown', this.onKeyPress, true);
        document && document.removeEventListener('sn:enter-up', this.enterUpHandler, true);
    }

    public componentDidUpdate(): void {
        this.onFocus();
    }

    public enterUpHandler = (e: any) => {
        const el: any = e.target;
        if (el.className.includes('aaf_focusable')) {
            this.setState({ element: e.target });
        }
    };

    private getTextBySteps(attribute: string): string {
        const { step, wfs } = this.state;
        let result: IStepsValue = {
            header: Translator.get('top_head_step_3_label', 'PASO 3 DE 3'),
            title: undefined,
            subtitle: wfs?.gatewaytext,
            next: Translator.get('hubgate_access_option_button_sucription', 'SIGUIENTE'),
            cancel: Translator.get('hubgate_access_option_button_cancel', 'CANCELAR'),
        };

        if (step === Steps.STEP_PIN) {
            const apaKeyTitle = 'hubgate_validationCode_title';
            const titlePIN = Translator.get(apaKeyTitle);
            result = {
                title: titlePIN === apaKeyTitle ? undefined : titlePIN,
                header: Translator.get('top_head_step_3_label', 'PASO 3 DE 3'),
                subtitle: Translator.get(
                    'hubgate_validationCode_subtitle',
                    'Código de validación enviado a tu celular'
                ),
                pin: Translator.get(
                    'hubgate_validationCode_sendPIN_button_sendPIN',
                    'REENVIAR PIN'
                ),
                next: Translator.get('hubgate_validationCode_option_button_next', 'SIGUIENTE'),
                cancel: Translator.get('hubgate_validationCode_option_button_cancel', 'CANCELAR'),
            };
        }

        return result[attribute] ?? '';
    }

    @autobind
    private handleChange(value: string, type: string): void {
        const { form } = this.state;
        let { errorFromBackend, errorFromBackendDoc } = this.state;
        this.isValidForm = value !== '';
        if (value === '' || value !== '') {
            errorFromBackend = '';
            errorFromBackendDoc = ''
        }
        const filteredValue = filterInputValue(value, type);
        this.setState({ errorFromBackend, errorFromBackendDoc, form: { ...form, [type]: filteredValue } } as IHubGateState);
    }

    private handleNextStep = (): void => {
        let { errorFromBackend, errorFromBackendDoc, element } = this.state;
        const { form, wfs, pbi, hasDocument } = this.state;
        type K = keyof typeof form;
        const data = this.getDataByDocument(hasDocument, 'nextStep');
        const elements = this.temp.getElementsByClassName('aaf_focusable');
        const arrElements: any = Array.from(elements);
        const arrValid = Array.from(elements).map((e: any) => {
            return form[e.id as K] === '';
        });

        const regExpPhoneNumber = GetRegExpMovil();
        const { account = false, numberField = '' } = data;
        const phoneNumber = account ? account : numberField;

        if (arrValid.includes(true)) {
            const input = arrElements[arrValid.findIndex((e) => e === true)];
            if (input.id === 'document') {
                errorFromBackendDoc = Translator.get('form_tooltip_empty_label_validation', 'Debes completar este campo para continuar.');
            } else if (input.id === 'mobile') {
                errorFromBackend = Translator.get('form_tooltip_empty_label_validation', 'Debes completar este campo para continuar.');
            }
        } else if (phoneNumber && regExpPhoneNumber !== null && !(regExpPhoneNumber.test(phoneNumber))) {
            errorFromBackend = Translator.get('form_tooltip_lengthPhoneNumber_label_validation', 'El número telefónico no es valido, verifícalo.');
        }
        else {
            this.setState({ isLoading: true });
            apiPaywayConfirm({
                pbi,
                wfs,
                formParams: { ...data },
            })
                .then((resp) => {
                    this.setState({
                        form: { ...form, access_pin_token: resp.response.access_pin_token },
                        isLoading: false,
                        step: Steps.STEP_PIN
                    });
                })
                .catch((err) => {
                    const { completeError } = err
                    let step = '';
                    if (completeError && completeError?.errors && completeError?.errors.code === "error_pin") {
                        step = Steps.STEP_PIN;
                    } else {
                        step = Steps.STEP_NUMBER;
                        showError(err);
                    }
                    this.setState({
                        isLoading: false, step
                    }, () => {
                        if (isModalHide()) {
                            setInitialFocus('.aaf_form-group-input-element .aaf_form-group-focus-pin', false);
                        }
                    });
                });
            this.isValidForm = false;
            errorFromBackend = '';
            errorFromBackendDoc = '';
            element = '';
        }
        this.setState({ errorFromBackend, errorFromBackendDoc, element });
    };

    private sendPin = (): void => {
        const { wfs, form, pbi, hasDocument } = this.state;
        const data = this.getDataByDocument(hasDocument, 'sendPin');
        this.setState({ isLoading: true });
        apiPaywayConfirm({
            pbi,
            wfs,
            formParams: { ...data },
        })
            .then((resp) => {
                this.setState({
                    form: { ...form, access_pin_token: resp.response.access_pin_token },
                    isLoading: false
                });
            })
            .catch((err) => {
                const { completeError } = err;

                if (completeError && completeError?.errors && completeError?.errors.code === "error_pin") {
                    // No hay accion, solo spinner en lo que se llama a la API
                } else {
                    showError(err);
                }
                this.setState({ isLoading: false });
            });
    };

    private getPlanName(producttype: any){
        return producttype.replace('_', ' ')
    }

    private setMetricsSuscription(pbi: any, wfs: any){
        if(!pbi.isSubscription) return;
        const productType = wfs.producttype.split('_');
        const metricsHistory = this.props.location.state.metricsHistory;
        let eventActionText = '';
        if(metricsHistory){
            eventActionText = metricsHistory.toLowerCase().includes('vcard') ? ADD_ON_VCARD : (metricsHistory.toLowerCase().includes('tv') ? ADD_ON_TV : ADD_ON_REGISTRO) ;
        } else{
            eventActionText = ADD_ON_REGISTRO;
        }

        if(pbi.family === CLAROVIDEO) {
            Utils.sendMetric(this.props,  SUSCRIPCION_CLARO_VIDEO_REGISTRO, EXITOSO_MENSUAL_ANUAL_METODO_DE_PAGO.concat(productType[1].toLowerCase()).concat(' - ',  wfs?.gatewaytext.toLowerCase()), COMPONENT_SUSCRIPCION);
        } else {
            Utils.sendMetric(this.props,  eventActionText, EXITOSO_MENSUAL_ANUAL_METODO_DE_PAGO.concat(pbi.family.toLowerCase()).concat(' - ',  wfs?.gatewaytext.toLowerCase()), COMPONENT_SUSCRIPCION);
        }
    }

    private setMetricsSeason(pbi: any, wfs: any){
        const isSeason =  wfs.producttype.toLowerCase().indexOf('season') > 0 ? true : false;
        const isEpisode =  wfs.producttype.toLowerCase().indexOf('episode') > 0 ? true : false;
        const episode = pbi.oneofferdesc.split(' ');
        const { worflowstart: {contentInfo}, } = this.state;
        if(contentInfo){
            if(isSeason) {
                Utils.sendMetric(this.props,  (contentInfo.contentTitle.toLowerCase()).concat(' - ',  wfs?.gatewaytext.toLowerCase()),contentInfo.contentOriginalTitle.toLowerCase(), COMPRAS_VCARD);
            } else if(isEpisode) {
                Utils.sendMetric(this.props,  (`${episode[1]} ${episode[2]}`).concat(' - ',  wfs?.gatewaytext.toLowerCase()),contentInfo.contentOriginalTitle.toLowerCase(), COMPRAS_VCARD);
            }else {
                Utils.sendMetric(this.props,  (pbi.oneofferdesc.toLowerCase()).concat(' - ',  wfs?.gatewaytext.toLowerCase()),contentInfo.contentTitle.toLowerCase(), COMPRAS_VCARD);
            }
        }
    }

    private sendGA4Metric = () => {
        const gA4 = new GA4();
        gA4.sendAddPaymentMethodEvent(PAYMENT_METHOD_TELCEL);
    }

    private handleSubmit = (): void => {
        let { errorFromBackend } = this.state;
        const {
            wfs,
            form: { pin, access_pin_token },
            pbi,
            pbi: { isSubscription },
            selectedPaymentMethod,
            hasDocument
        } = this.state;
        this.setMetricsSuscription(pbi, wfs);
        const data = this.getDataByDocument(hasDocument, 'submit');
        let cb = isSubscription ? (resp: object) => this.redirectAddon(resp) : (resp: any) => this.redirectVCard(resp);
        if (pin?.length === 0) {
            errorFromBackend = Translator.get('form_tooltip_empty_label_validation', 'Debes completar este campo para continuar.');
        } else {
            this.setState({ isLoading: true });
            errorFromBackend = '';
            this.sendGA4Metric();
            apiPaywayConfirm({
                pbi,
                wfs,
                formParams: { ...data },
                extra: { access_pin_token, access_pin_code: pin }
            })
                .then((resp) => {
                    this.setState({ isLoading: false });
                    this.setMetricsSeason(pbi, wfs);
                    onPaymetSuccess(resp, pbi, wfs, selectedPaymentMethod, cb);
                })
                .catch((err) => {
                    showError(err);
                    this.setState({ isLoading: false });
                });
        }
        this.setState({ errorFromBackend });
    }

    private getDataByDocument(hasDocument: boolean, step: string): object {
        const {
            wfs,
            form: { mobile, document, pin },
            selectedPaymentMethod,
        } = this.state;
        const type = wfs!.hubCorpEnabled ? 'account' : 'numberField';
        let obj = {
            [type]: mobile,
            payway: selectedPaymentMethod,
            pin: step === 'submit' ? pin : ''
        };
        if (hasDocument) {
            obj = {
                ...obj,
                document
            };
        }
        return obj;
    }

    @autobind
    private showTicket(resp: any, groupId: string, islive: boolean) {
        const { showModal } = this.props;
        const { type, worflowstart: { contentInfo }, pbi: { producttype, currency, price, family, periodicity, frequency, oneoffertype, bonus }, selectedPaymentMethod } = this.state;
        const region = DeviceStorage.getItem('region');
        const { response: { paymentMethodData: { account = '' } = {}, end_date: { day = '', month = '', year = '' } = {}, payway_token = '' } = {} } = resp || {};
        const payDate = `${day} ${month} ${year}`;
        const {pbi, wfs} = this.state;
        const productType = wfs.producttype.split('_');
        const paymentMethodLabel = account ? `${Translator.get(`ticket_subscription_${selectedPaymentMethod}_label`, '')} ${account}` : Translator.get(`ticket_subscription_${selectedPaymentMethod}_label`, '')


        const data = {
            pbi,
            total: UtilsPagos.getTotalAndPeriodicity(currency, price, periodicity),
            duration: `${Translator.get(periodicity, '')}`,
            frequency: frequency,
            days: Translator.get(`bonus_${producttype}`),
            content: Translator.get(`Ticket_Transaccion_TextoDescripcion_${producttype}`, ''),
            payment_method: paymentMethodLabel,
            img_largeSub: Assets.get(`${region}_transactional_${family}_poster`, ''),
            img_large: contentInfo?.contentImageMedium,
            providerImage: Assets.get(`transactional_${family}_logo`),
            title: contentInfo?.contentTitle || '',
            type: type,
            from: this.from
        };
        const modal = {
            modalType: AAF_MODAL_SUCCESS_SUSCRIPTION,
            modalProps: {
                data: handleTypeModal({ ...data, next_pay: payDate }),
                handlePlay: () => this.from ? this.handleAddOn(resp) : this.handlePlay(groupId, payway_token, islive),
                handleVCard: () => this.handleVCard(groupId),
                payment_methods_experience: enablePaymentMethodExperience()
            }
        };

        if(pbi.family === CLAROVIDEO) {
            Utils.sendMetric(this.props,  SUSCRIPCION_CLARO_VIDEO_REGISTRO, EXITOSO_MENSUAL_ANUAL_METODO_DE_PAGO.concat(productType[1].toLowerCase()).concat(' - ',  wfs?.gatewaytext.toLowerCase()), COMPONENT_SUSCRIPCION);
        } else {
            Utils.sendMetric(this.props,  ADD_ON_REGISTRO, EXITOSO_MENSUAL_ANUAL_METODO_DE_PAGO.concat(pbi.family.toLowerCase()).concat(' - ',  wfs?.gatewaytext.toLowerCase()), COMPONENT_SUSCRIPCION);
        }
        showModal(modal);
    }

    private redirectAddon(resp: any): void {
        const { pbi: { groupId = '', oneoffertype = '', islive = false }, worflowstart: { selectedPaymentMethod } } = this.state;
        const isOneClicFlow = groupId === '' ? false : true;
        const oneClicKey = `${oneoffertype}_${selectedPaymentMethod}`;
        if (UtilsPagos.oneClicBuyHiddeConfirm(isOneClicFlow, oneClicKey)) {
            if (UtilsPagos.oneClicBuyRedirectPlayer(isOneClicFlow, oneClicKey)) {
                const { response: { payway_token = '' } = {} } = resp || {};
                this.handlePlay(groupId, payway_token, islive);
            }
            else {
                // este caso aplica cuando no se tiene activado el one clic muestra modal de compra exitosa
                this.showTicket(resp, groupId, islive);
            }
        } else {
            // aplica para plan selector y vcard cuando no hay one clic
            this.showTicket(resp, groupId, islive);
        }
    }

    private redirectVCard(resp?: any): void {
        const { pbi: { groupId = '', oneoffertype = '', islive = false }, worflowstart: { selectedPaymentMethod } } = this.state;
        const isOneClicFlow = groupId === '' ? false : true;
        const oneClicKey = `${oneoffertype}_${selectedPaymentMethod}`;
        if (UtilsPagos.oneClicBuyHiddeConfirm(isOneClicFlow, oneClicKey)) {
            if (UtilsPagos.oneClicBuyRedirectPlayer(isOneClicFlow, oneClicKey)) {
                setTimeout(() => {
                    const { history } = this.props;
                    const nav = Utils.getApaMetadataKey('links_nav_configuration', Utils.mock_links_nav_configuration());
                    if (islive) {
                        if(nav && nav.home) {
                            history.replace(`/node/${nav.home}`);
                        }
                    }
                    else if (groupId) {
                        this.handleVCard(groupId);
                    }
                }, 0);
            }
            else {
                // este caso aplica cuando no se tiene activado el one clic muestra modal de compra exitosa
                this.showTicket(resp, groupId, islive);
            }
        } else {
            // aplica para plan selector y vcard cuando no hay one clic
            this.showTicket(resp, groupId, islive);
        }
    }

    private handleAddOn(resp: any) {
        const { history, nodes } = this.props;
        const { response: { node_id = '' } = {} } = resp || {};
        let nodeString: string = '';
        const filterNodes = nodes.filter((value: any) => value.code === 'playandgo');
        const resultChilds = filterNodes.map((res: any) => {
            const childsValue = res.childs;
            return childsValue;
        });

        for (let index = 0; index < resultChilds.length; index++) {
            const element = resultChilds[index];
            element.map((resId: any) => {
                if (resId.id === node_id) {
                    return nodeString = resId.code;
                }
            });
        }

        this.setState({ isLoading: false });
        history.replace(`/node/${nodeString ? nodeString : 'homeuser'}`);
    }

    @autobind
    private handlePlay(groupId: string, payway_token: string, islive: boolean) {
        if (groupId) {
            redirectPlayerOneClic(groupId, islive, payway_token, () => {
                this.handleVCard(groupId);
            })
        }
    }

    @autobind
    private handleVCard(groupId: string) {
        if (groupId) {
            const { history } = this.props;
            history.replace(`/vcard/${groupId}`);
        }
    }

    private handleCancel = (): void => {
        const { wfs } = this.state;
        Utils.sendMetric(this.props,  METODO_DE_PAGO, `${wfs?.gatewaytext.toLowerCase()} - ${CANCELAR_MEDIO_PAGO}`, COMPONENTE_TICKER);
        const { step } = this.state;
        const { history } = this.props;
        if (step === Steps.STEP_NUMBER) {
            history.goBack();
        } else {
            this.setState({ step: Steps.STEP_NUMBER });
            if (isModalHide()) {
                setInitialFocus('.aaf_form-group-input-element .aaf_focusable', true);
            }
        }
    };

    @autobind
    private handleBack(): void {
        this.handleCancel();
    }

    @autobind
    private onKeyPress(e: any): void {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        if (currentKey === 'YELLOW') {
            this.handleCancel();
        } else if (currentKey === 'BACK') {
            this.handleBack();
        }
    }

    @autobind
    private onFocus(): void {
        const { element, step } = this.state;
        let activeDoc: boolean = false;
        let activeMobile: boolean = false;
        const numberElments = document.getElementsByClassName('aaf_focusable');
        if (numberElments.length > 1 && step === Steps.STEP_NUMBER) {
            activeDoc = true;
            if (element.id === 'mobile') {
                activeDoc = false;
                activeMobile = true;
            }
        } else {
            activeMobile = true;
        }

        onFocusMultipleElements([{ id: 'document', activeElement: activeDoc }, { id: 'mobile', activeElement: activeMobile }, { id: 'pin', activeElement: true }]);
    }

    public render(): JSX.Element {
        const { step, hasDocument, isLoading, errorFromBackend, errorFromBackendDoc } = this.state;
        const title = this.getTextBySteps('title');
        if (isLoading) return <Spinner className={cls(`${PAYMENT_TELCEL}-spinner`)} loadingMessage='' />;
        return (
            <Grid className={Device.getDevice().getPlatform()}>
                <HeaderCompound
                    disabled
                    align='right'
                    onClick={this.handleCancel}
                    textBack={Translator.get('top_head_option_button_back', 'REGRESAR')}
                    icon={`${Assets.get('top_head_option_back')}`}
                    onFocus={this.onFocus}
                />
                <Row>
                    <Column lg={12}>
                        <Heading size={2} className={cls(`${PAYMENT_TELCEL}-title`, this.from ? 'visible' : 'hidden')}>
                            {this.getTextBySteps('header')}
                        </Heading>
                    </Column>
                </Row>
                <Row>
                    <Form id="payment-telcel-form">
                        <Column lg={6} className={cls(`${PAYMENT_TELCEL}-column-keyboard`)}>
                            <Keyboard id="Keyboard" onFocus={this.onFocus} filteredFuncion={filterInputValue} />
                        </Column>
                        <Column lg={6} className={cls(`${PAYMENT_TELCEL}-column-inputs`)}>
                            <Row className={cls(`${PAYMENT_TELCEL}-row-inputs`)}>
                                <Column lg={12}>
                                    {step === Steps.STEP_PIN && title && (
                                        <Heading
                                            size={1}
                                            className={cls(`${PAYMENT_TELCEL}-header-form`)}>
                                            {title}
                                        </Heading>
                                    )}
                                    <Heading
                                        size={1}
                                        className={cls(`${PAYMENT_TELCEL}-title-form`)}
                                    >
                                        {this.getTextBySteps('subtitle')}
                                    </Heading>
                                </Column>
                                <Row className={cls(`${PAYMENT_TELCEL}-column-input`)}>
                                    {this.subtitleLabel !== null && step === Steps.STEP_NUMBER && <Column lg={12} className={`${PAYMENT_TELCEL}-label`}>
                                        <span>{this.subtitleLabel}</span>
                                    </Column>}
                                    {hasDocument && step === Steps.STEP_NUMBER && (
                                        <Column lg={12} className={`${PAYMENT_TELCEL}-bottom`}>
                                            <FormInput
                                                focusWhenMount
                                                type="numeric"
                                                name="document"
                                                id="document"
                                                onChange={(e) => this.handleChange(e, 'document')}
                                                placeholder={Translator.get(
                                                    'hubgate_idNumber_placeHolder_textfield',
                                                    'Cédula de identidad o Pasaporte'
                                                )}
                                                errorFromBackend={errorFromBackendDoc}
                                                onFocus={this.onFocus}
                                            />
                                        </Column>
                                    )}
                                    <Column lg={12} className={step !== Steps.STEP_NUMBER ? 'hide' : ''}>
                                        <FormInput
                                            focusWhenMount
                                            type="mobile"
                                            name="mobile"
                                            id="mobile"
                                            onChange={(e) => this.handleChange(e, 'mobile')}
                                            placeholder={Translator.get(
                                                'hubgate_phoneNumber_placeHolder_textfield',
                                                'Ingresa tu teléfono móvil'
                                            )}
                                            errorFromBackend={errorFromBackend}
                                            /*maxLength={getNumberLength()}*/
                                            onFocus={this.onFocus}
                                        />
                                    </Column>
                                    {step === Steps.STEP_PIN && (
                                        <Row>
                                            <Column lg={7}>
                                                <FormInput
                                                    focusWhenMount
                                                    type="pin"
                                                    name="pin"
                                                    id='pin'
                                                    onChange={(e) => this.handleChange(e, 'pin')}
                                                    errorFromBackend={errorFromBackend}
                                                    maxLength={5}
                                                />
                                            </Column>
                                            <Column
                                                lg={4}
                                                className={cls(`${PAYMENT_TELCEL}-column-send-pin`)}
                                            >
                                                <Button
                                                    activate
                                                    type="button"
                                                    variant="default"
                                                    className={cls(
                                                        `focusable`,
                                                        `${PAYMENT_TELCEL}-button-send-pin`
                                                    )}
                                                    onClick={this.sendPin}
                                                    block
                                                    onFocus={this.onFocus}
                                                >
                                                    {this.getTextBySteps('pin')}
                                                </Button>
                                            </Column>
                                        </Row>
                                    )}
                                </Row>
                                <Column lg={12}>
                                    <Button
                                        activate
                                        type="button"
                                        variant="primary"
                                        disabled={!this.isValidForm}
                                        className={cls(
                                            `focusable`,
                                            `${PAYMENT_TELCEL}-button-next`
                                        )}
                                        onClick={step === Steps.STEP_NUMBER ? this.handleNextStep : this.handleSubmit}
                                        block
                                        onFocus={this.onFocus}
                                    >
                                        {this.getTextBySteps('next')}
                                    </Button>
                                </Column>
                                <Column lg={12} className={cls(`${PAYMENT_TELCEL}-column-next`)}>
                                    <Button
                                        activate
                                        type="button"
                                        className={cls(
                                            `focusable`,
                                            `${PAYMENT_TELCEL}-button-cancel`
                                        )}
                                        onClick={this.handleCancel}
                                        block
                                        onFocus={this.onFocus}
                                    >
                                        {this.getTextBySteps('cancel')}
                                    </Button>
                                </Column>
                            </Row>
                        </Column>
                    </Form>
                </Row>
            </Grid>
        );
    }
}

const mapDispatchToProps = {
    showModal,
    setMetricsEvent
};

export default connect(null, mapDispatchToProps)(HubGate);



// WEBPACK FOOTER //
// ./src/payments/HubGate/index.tsx